// Central content + media for Precision Handyman Services
import {
  Hammer, Home, Wrench, Layers, Bath, Snowflake, ShieldCheck,
} from "lucide-react";

export const BUSINESS = {
  name: "Precision Handyman Services",
  tagline: "Veteran Owned & Operated",
  motto: "Quality Work. Stronger Homes. Built For Life.",
  phone: "865-333-0327",
  phoneHref: "tel:8653330327",
  smsHref: "sms:8653330327",
  email: "Mccoigt@gmail.com",
  emailHref: "mailto:Mccoigt@gmail.com",
  serviceArea: "East Tennessee",
  facebook: "https://www.facebook.com/share/1EVsAffYHp/?mibextid=wwXIfr",
};

// Hero background: veteran/handyman branded image (matches flyer aesthetic)
export const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/09c1ce69-aef4-4d68-9258-0061fa207834/images/401c79437889dea0a9314326b3c610ffed6d82b03c977d6fd1e8a61772998e0f.jpeg";
export const HERO_BG_ALT =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_handyman-showcase-3/artifacts/ggrqcosa_IMG_5928.webp";

export const TRUST_POINTS = [
  "Licensed & Insured",
  "Free Estimates",
  "Honest Pricing",
  "Veteran Values",
];

export const SERVICES = [
  {
    icon: Home,
    title: "Roofing",
    desc: "Repairs & full replacements. Shingle, metal & more.",
    image:
      "https://images.unsplash.com/photo-1632759145351-1d592919f522?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxyZXNpZGVudGlhbCUyMHJvb2ZpbmclMjBjb25zdHJ1Y3Rpb258ZW58MHx8fHwxNzg2ODkzODA5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: ShieldCheck,
    title: "Crawlspace",
    desc: "Encapsulation, vapor barriers & moisture control.",
    image:
      "https://images.unsplash.com/photo-1711375201123-61eddb7804d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxhdHRpYyUyMGluc3VsYXRpb24lMjBpbnN0YWxsYXRpb258ZW58MHx8fHwxNzg2ODk1NDM5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Wrench,
    title: "Plumbing",
    desc: "Fixtures, leaks, water lines & drains. Fixed right.",
    image:
      "https://images.unsplash.com/photo-1694827893591-af9b80361599?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxwbHVtYmVyJTIwd3JlbmNoJTIwY29wcGVyJTIwcGlwZSUyMHJlcGFpcnxlbnwwfHx8fDE3ODY4OTU0NjJ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Layers,
    title: "Decks",
    desc: "Build, repair, stain & seal. Built strong, built to last.",
    image:
      "https://images.unsplash.com/photo-1623195372782-57a1486af9a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxkZWNrJTIwYnVpbGRpbmclMjBvdXRkb29yfGVufDB8fHx8MTc4Njg5MzgwOXww&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Bath,
    title: "Bathroom Remodels",
    desc: "Full remodels, tile, vanities & fixture upgrades.",
    image:
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiYXRocm9vbSUyMHJlbW9kZWx8ZW58MHx8fHwxNzg2ODkzODA5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Snowflake,
    title: "Attic Insulation",
    desc: "Spray foam & insulation installs for efficient homes.",
    image:
      "https://images.unsplash.com/photo-1591684080176-bb2b73f9ec68?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxhdHRpYyUyMGluc3VsYXRpb24lMjBpbnN0YWxsYXRpb258ZW58MHx8fHwxNzg2ODk1NDM5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Hammer,
    title: "General Repairs",
    desc: "No job too small. Maintenance & everything in between.",
    image:
      "https://images.unsplash.com/photo-1765518440022-10242cc86895?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxoYW5keW1hbiUyMHdvcmtpbmclMjBob21lJTIwcmVwYWlyJTIwdG9vbCUyMGJlbHR8ZW58MHx8fHwxNzg0NjY4OTUyfDA&ixlib=rb-4.1.0&q=85",
  },
];

// Recent Work — the client's real job photos.
// `rotate`: true = rotate-90 (CW), "ccw" = -rotate-90, false = upright as stored.
export const RECENT_WORK = [
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_handyman-showcase-3/artifacts/5fp5xy13_IMG_0746.JPG",
    caption: "Exterior Stone Siding",
    category: "Exterior",
    rotate: false,
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_handyman-showcase-3/artifacts/w6zfyg37_IMG_0743.webp",
    caption: "Deck & Porch Staining",
    category: "Decks",
    rotate: false,
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_handyman-showcase-3/artifacts/hsp7ri1g_IMG_0745.webp",
    caption: "Interior Remodel & Framing",
    category: "Remodel",
    rotate: false,
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_handyman-showcase-3/artifacts/x1c46qou_IMG_0747.webp",
    caption: "Crawlspace Support Jacks",
    category: "Crawlspace",
    rotate: false,
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_handyman-showcase-3/artifacts/ggrqcosa_IMG_5928.webp",
    caption: "Custom Pole Barn Build",
    category: "Construction",
    rotate: true,
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_handyman-showcase-3/artifacts/go35itam_IMG_5763.webp",
    caption: "Framing & Structural Work",
    category: "Construction",
    rotate: true,
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_handyman-showcase-3/artifacts/al8j9ead_IMG_5729.webp",
    caption: "Attic Spray Foam Insulation",
    category: "Insulation",
    rotate: "180",
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_handyman-showcase-3/artifacts/dkrpvs5m_IMG_0734.webp",
    caption: "Septic System Installation",
    category: "Excavation",
    rotate: true,
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_handyman-showcase-3/artifacts/22vte0vk_IMG_6108.webp",
    caption: "Garage Siding & House Wrap",
    category: "Exterior",
    rotate: true,
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_handyman-showcase-3/artifacts/h3ytbktv_IMG_5986.webp",
    caption: "Bathroom Renovation",
    category: "Remodel",
    rotate: true,
  },
  {
    src: "https://customer-assets-cm19k8pv.emergentagent.net/job_09c1ce69-aef4-4d68-9258-0061fa207834/artifacts/weycuvy7_IMG_6109.webp",
    caption: "Exterior Siding & Utility Work",
    category: "Exterior",
    rotate: true,
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_handyman-showcase-3/artifacts/a7oea0bj_IMG_1122.webp",
    caption: "Carport & Exterior Repair",
    category: "Repairs",
    rotate: false,
  },
];

// Veteran / trust section image (rustic American flag)
export const VETERAN_IMG =
  "https://images.unsplash.com/photo-1765880106976-25a65e531891?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxhbWVyaWNhbiUyMGZsYWclMjBydXN0aWMlMjB2aW50YWdlfGVufDB8fHx8MTc4Njg5MzgxMHww&ixlib=rb-4.1.0&q=85";
